import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "current-balance" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header-3-red" }, "Opt Balance", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "balance-total"
}
const _hoisted_5 = {
  key: 1,
  class: "balance-total"
}
const _hoisted_6 = {
  key: 0,
  class: "profile-container"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "profile-container"
}
const _hoisted_9 = { class: "profile-initials" }
const _hoisted_10 = {
  key: 2,
  class: "profile-container"
}
const _hoisted_11 = { class: "meetings-bar" }
const _hoisted_12 = { class: "all-meetings flex-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "header-5" }, "Scheduled", -1 /* HOISTED */)
const _hoisted_14 = { class: "total-meetings" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "header-5" }, "Held", -1 /* HOISTED */)
const _hoisted_16 = { class: "total-meetings" }
const _hoisted_17 = {
  key: 0,
  class: "notifications"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "welcome" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Welcome to your Opt Profile Page"),
  /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Tap below to create your first meeting invite.")
], -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "notifications"
}
const _hoisted_21 = {
  key: 0,
  class: "next-meeting"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "This meeting is currently in progress", -1 /* HOISTED */)
const _hoisted_23 = {
  key: 1,
  class: "next-meeting"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Please review your payment methods for these meetings", -1 /* HOISTED */)
const _hoisted_25 = {
  key: 2,
  class: "next-meeting"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Meetings Awaiting Feedback", -1 /* HOISTED */)
const _hoisted_27 = {
  key: 3,
  class: "next-meeting"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Meetings Awaiting Reschedule", -1 /* HOISTED */)
const _hoisted_29 = {
  key: 4,
  class: "next-meeting"
}
const _hoisted_30 = { class: "view-all" }
const _hoisted_31 = {
  key: 5,
  class: "next-meeting"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "You have no upcoming meetings", -1 /* HOISTED */)
const _hoisted_33 = { class: "view-all" }
const _hoisted_34 = {
  key: 6,
  class: "dashboard-notifications"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Congrats on accepting your first Opt meeting Invite!", -1 /* HOISTED */)
const _hoisted_36 = { class: "learn-more" }
const _hoisted_37 = { class: "button-container-home flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home", {'no-scroll': $setup.noScroll}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "balance-container center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goTo('/balance')))
        }, [
          _hoisted_3,
          _createElementVNode("div", {
            class: _normalizeClass(["balance-indicator", {negative: $setup.balance < 0}])
          }, [
            _createTextVNode(_toDisplayString($setup.balance < 0 ? '-' : '') + "$", 1 /* TEXT */),
            ( $setup.balance == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "0"))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString((Math.abs($setup.balance).toFixed(2))), 1 /* TEXT */))
          ], 2 /* CLASS */)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["profile", {'proxy-user': $setup.userspace.isProxy}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goTo('/settings')))
        }, [
          ($setup.user?.profilePic)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "profile-pic",
                  src: $setup.user.profilePic
                }, null, 8 /* PROPS */, _hoisted_7)
              ]))
            : ($setup.user?.name?.firstName && $setup.user?.name?.lastName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString($setup.user.name.firstName[0] + $setup.user.name.lastName[0]), 1 /* TEXT */)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10)),
          _createElementVNode("div", {
            class: _normalizeClass(["user-name", {rightAlign: $setup.user.name.firstName.length > 8}])
          }, _toDisplayString($setup.user.name.firstName), 3 /* TEXT, CLASS */)
        ], 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "header-4 meetings-header",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goTo('/meetings')))
          }, " Opt Meetings")
        ]),
        _createElementVNode("div", {
          class: "upcoming-meetings flex-center",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goTo('/meetings')))
        }, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString($setup.scheduledCount), 1 /* TEXT */)
        ]),
        _createElementVNode("div", {
          class: "previous-meetings flex-center",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.goTo('/meetings', '#held')))
        }, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString($setup.heldCount), 1 /* TEXT */)
        ])
      ]),
      ($setup.showWelcome)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            ($setup.currentMeetings.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentMeetings, (meeting) => {
                    return (_openBlock(), _createBlock($setup["UpcomingMeeting"], {
                      class: "future",
                      meeting: meeting,
                      "onHandle:showPopup": $setup.handlePopup
                    }, null, 8 /* PROPS */, ["meeting"]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              : ($setup.failingPaymentMeetings.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.failingPaymentMeetings, (meeting) => {
                      return (_openBlock(), _createBlock($setup["UpcomingMeeting"], {
                        class: "future",
                        meeting: meeting,
                        "onHandle:showPopup": ($event: any) => ($setup.goTo(`/retry-payment/${meeting.payerLink}`))
                      }, null, 8 /* PROPS */, ["meeting", "onHandle:showPopup"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]))
                : ($setup.confirmableMeetings.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.confirmableMeetings, (meeting) => {
                        return (_openBlock(), _createBlock($setup["UpcomingMeeting"], {
                          class: "future",
                          meeting: meeting,
                          "onHandle:showPopup": $setup.handlePopup
                        }, null, 8 /* PROPS */, ["meeting"]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]))
                  : ($setup.awaitingRescheduleMeetings.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.awaitingRescheduleMeetings, (meeting) => {
                          return (_openBlock(), _createBlock($setup["UpcomingMeeting"], {
                            class: "future",
                            meeting: meeting,
                            "onHandle:showPopup": $setup.handlePopup
                          }, null, 8 /* PROPS */, ["meeting"]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]))
                    : ($setup.scheduledMeetings.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scheduledMeetings, (meeting) => {
                            return (_openBlock(), _createBlock($setup["UpcomingMeeting"], {
                              class: "future",
                              meeting: meeting,
                              "onHandle:showPopup": $setup.handlePopup
                            }, null, 8 /* PROPS */, ["meeting"]))
                          }), 256 /* UNKEYED_FRAGMENT */)),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("a", {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.goTo('/meetings')))
                            }, "View All Meetings")
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("a", {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.goTo('/meetings')))
                            }, "View All Meetings")
                          ])
                        ])),
            ($setup.showFirstInvite)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("a", {
                      onClick: _cache[7] || (_cache[7] = () => {})
                    }, "Learn More about Opt")
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("button", {
          class: "primary send-invite-home",
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.goTo('/links')))
        }, "Meeting Types")
      ])
    ]),
    _createVNode(_Transition, {
      onBeforeEnter: _cache[9] || (_cache[9] = ($event: any) => ($setup.noScroll = true)),
      onAfterEnter: _cache[10] || (_cache[10] = ($event: any) => ($setup.noScroll = false)),
      onBeforeLeave: _cache[11] || (_cache[11] = ($event: any) => ($setup.noScroll = true)),
      onAfterLeave: _cache[12] || (_cache[12] = ($event: any) => ($setup.noScroll = false))
    }, {
      default: _withCtx(() => [
        ($setup.payerConfirmableMeetings.length > 0  && $setup.showConfirm)
          ? (_openBlock(), _createBlock($setup["meetingPopup"], {
              key: 0,
              class: "meetingPopup",
              selectedMeeting: $setup.payerConfirmableMeetings[0],
              onClosePopup: $setup.closePopup
            }, null, 8 /* PROPS */, ["selectedMeeting"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_Transition, {
      onBeforeEnter: _cache[13] || (_cache[13] = ($event: any) => ($setup.noScroll = true)),
      onAfterEnter: _cache[14] || (_cache[14] = ($event: any) => ($setup.noScroll = false)),
      onBeforeLeave: _cache[15] || (_cache[15] = ($event: any) => ($setup.noScroll = true)),
      onAfterLeave: _cache[16] || (_cache[16] = ($event: any) => ($setup.noScroll = false))
    }, {
      default: _withCtx(() => [
        ($setup.showPopup)
          ? (_openBlock(), _createBlock($setup["meetingPopup"], {
              key: 0,
              class: "note",
              selectedMeeting: $setup.selectedMeeting,
              onClosePopup: $setup.closePopup
            }, null, 8 /* PROPS */, ["selectedMeeting"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 2 /* CLASS */))
}